// Dashboard Events map & categories page translations (en-US), loaded into dashboard.events.categories by ../en-US.events.js
module.exports = {
  menu: "Map & Categories",
  title: "Map & Categories",
  description: "Active events on {end} — {selection}.",
  all: "All",
  allCategories: "all categories",
  activeSub: "active",
  kpis: {
    active: "Active events",
    topContinent: "Top continent",
    topCity: "Top city",
    cities: "Cities with events",
  },
  info: {
    active: "Active events running on the last day of the period, in the selected category.\nSource: Firebase (events).",
    topContinent: "Continent with the most active events on the last day of the period, in the selected category.\nSource: Firebase (events).",
    topCity: "City with the most active events on the last day of the period, in the selected category.\nSource: Firebase (events).",
    cities: "Cities with at least one active event on the last day of the period, in the selected category.\nSource: Firebase (events).",
  },
  hints: {
    ofActive: "{pct} of all active events",
    ofEvents: "{pct} of events",
    events: "{n} events",
  },
  panels: {
    map: "Heat map — {selection}",
    mapNote: "The category buttons above filter every block of the page. Use the map zoom to see a country or city in detail.",
    continents: "Events by continent",
    categories: "Events by category",
    topCities: "Top cities — {category}",
    matrix: "Category by continent — active events",
    continentsOf: "Continents — {category}",
    matrixNote: "The greener, the more events in that combination.",
  },
  table: {
    category: "Category",
    total: "Total",
  },
  continentsShort: {
    europe: "Europe",
    southAmerica: "S. America",
    northAmerica: "N. America",
    africa: "Africa",
    asia: "Asia",
    oceania: "Oceania",
  },
  panelInfo: {
    map: "Active events on the last day of the period by place, in the selected category.\nSource: Firebase (events).",
    continents: "Active events on the last day of the period by continent.\nSource: Firebase (events).",
    topCities: "Cities with the most active events of the selected category.\nSource: Firebase (events).",
    categories: "Active events on the last day of the period by category.\nSource: Firebase (events).",
    matrix: "Active events on the last day of the period by category and continent.\nSource: Firebase (events).",
  },
};
